/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Close: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19.8229 2.05535C19.9205 1.95775 20.0788 1.95782 20.1764 2.05535L21.944 3.82293C22.0417 3.92056 22.0417 4.07882 21.944 4.17645L14.1208 11.9997L21.944 19.8229C22.0417 19.9206 22.0417 20.0788 21.944 20.1764L20.1764 21.944C20.0788 22.0417 19.9206 22.0417 19.8229 21.944L11.9997 14.1208L4.17645 21.944C4.07882 22.0417 3.92056 22.0417 3.82293 21.944L2.05535 20.1764C1.95782 20.0788 1.95775 19.9205 2.05535 19.8229L9.8786 11.9997L2.05535 4.17645C1.95782 4.07881 1.95775 3.92053 2.05535 3.82293L3.82293 2.05535C3.92053 1.95775 4.07881 1.95782 4.17645 2.05535L11.9997 9.8786L19.8229 2.05535Z'
      fill='currentColor'
    />
  </React.Fragment>
)
